import { IAutoCompleteType } from '@patsnap/synapse_common_interface'
import { I18nLang } from '../../../i18n'

export const autoCompleteTypeLangMap: Partial<Record<IAutoCompleteType, Record<I18nLang, string>>> = {
  DrugType: {
    cn: '药物类型',
    en: 'Drug Type',
    jp: 'モダリティ',
  },
  Target: {
    cn: '靶点',
    en: 'Target',
    jp: '標的',
  },
  Disease: {
    cn: '适应症',
    en: 'Indication',
    jp: '適応症',
  },
  Mechanism: {
    cn: '作用机制',
    en: 'Mechanism',
    jp: '作用機序',
  },
  Organization: {
    cn: '机构',
    en: 'Organization',
    jp: '機関',
  },
  Drug: {
    cn: '药物',
    en: 'Drug',
    jp: '医薬品',
  },
}
